import React from 'react';
import { Select as AntdSelect, SelectProps } from 'antd';
import styled from '@emotion/styled';

const StyledSelect = styled(AntdSelect)`
  width: 100%;
`;

const Select = React.forwardRef(
  (
    {
      prefix,
      ...props
    }: Partial<
      SelectProps & {
        prefix: React.ReactNode;
      }
    >,
    ref
  ) => {
    return (
      <div>
        {prefix}
        <StyledSelect ref={ref} {...(props as any)} />
      </div>
    );
  }
);
Select.displayName = 'Select';

export default Select;
